<template>
  <v-layout
      row
      align-center
  >
    <v-flex
        class="pa-2 ma-1"
    >
      <!--            <breadcrumbs-->
      <!--                :items="breadcrumbsItems"-->
      <!--            ></breadcrumbs>-->
      <v-card class="ma-1" outlined>
        <v-card>
          <v-row>
            <v-col>
              <v-card-title>{{ queue.name }}</v-card-title>
              <v-card-subtitle>{{ queue.description }}</v-card-subtitle>
            </v-col>
            <v-col style="text-align: end; right: 15px">
              <vue-excel-xlsx
                  :data="exportdata"
                  :columns="columns"
                  :filename="exportFilename"
                  :sheetname="'sheet1'"
              >
                <v-btn class="primary ma-1 font-weight-bold">
                  Export
                </v-btn>
              </vue-excel-xlsx>
            </v-col>
          </v-row>
          <v-col cols="12" sm="6" md="4">
            <v-dialog
                ref="dialog"
                v-model="datepicker"
                :return-value.sync="daterange"
                persistent
                width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="dateRangeText"
                    label="Pick a date"
                    prepend-icon="event"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="daterange" scrollable range>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="datepicker = false">Cancel</v-btn>
                <v-btn text color="primary" @click="$refs.dialog.save(daterange)">OK</v-btn>
              </v-date-picker>
            </v-dialog>
          </v-col>

          <v-text-field
              v-model="searchPast"
              append-icon="mdi-magnify"
              label="Search"
              hide-details
              class="ma-1 col-sm-4 pl-2 pb-4"
              outlined
              autocomplete="off"
              dense
          ></v-text-field>
          <div v-if="exportdata.length > 0">
            <v-data-table
                :headers="pastHeaders"
                item-key="id"
                :items="exportdata"
                :search="searchPast"
                dense
                :sort-by="['created_at']"
                :sort-desc="[true]"
                class="display-3 font-weight-medium"
            >
            </v-data-table>
          </div>
        </v-card>

      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from 'axios'

export default {
  name: 'queue-admin',
  data: () => ({
    tab: null,
    qList: [],
    pastList: [],
    called: [],
    search: '',
    searchPast: '',
    dialog: false,
    daterange: [],
    datepicker: false,
    exportdata: [],
    pastHeaders: [
      {
        text: 'Name',
        value: 'name'
      },
      {
        text: 'Phone No.',
        value: 'phone_no',
      },
      {
        text: 'Email',
        value: 'email',
      },
      {
        text: 'Appointment',
        value: 'appointment_date',
      },
      {
        text: 'Notify at',
        value: 'called_at',
      },
      {
        text: 'Service',
        value: 'service',
      },
      {
        text: 'Status',
        value: 'status',
      },
    ],
    columns: [
      {
        label: 'Name',
        field: 'name'
      },
      {
        label: 'Phone No.',
        field: 'phone_no',
      },
      {
        label: 'Email',
        field: 'email',
      },
      {
        label: 'Appointment',
        field: 'appointment_date',
      },
      {
        label: 'Notify at',
        field: 'called_at',
      },
      {
        label: 'Service',
        field: 'service',
      },
      {
        label: 'Status',
        field: 'status',
      },
    ],
    services: [],
    breadcrumbsItems: '',
  }),
  computed: {
    dateRangeText() {
      return this.daterange.join(' ~ ')
    },
    exportFilename() {
      return 'this'
    },
  },
  props: ['outlet', 'queue'],
  methods: {
    getRecordByDate() {
      let daterange = this.daterange;
      let qid = this.queue.id;
      axios.post('/api/getExportRecordByDateRange', {
        qid: qid,
        daterange: daterange
      }).then(response => {
        this.exportdata = response.data;
      });
    },
  },
  beforeMount() {
    this.exportdata = [];
    axios.get('/api/getServices?oid=' + this.outlet.id).then(response => {
      this.services = response.data
    });
    // this.breadcrumbsItems = [
    //     {
    //         disabled: false,
    //         href: '/',
    //         link: true,
    //         text: 'Home',
    //     },
    //     {
    //         disabled: false,
    //         href: '/outlet/' + this.outlet.id + '/edit',
    //         link: true,
    //         text: this.outlet.name,
    //     },
    //     {
    //         disabled: false,
    //         href: '/outlet/' + this.outlet.id + '/queue/' + this.queue.id,
    //         link: true,
    //         text: this.queue.name,
    //     },
    //     {
    //         disabled: true,
    //         href: '#',
    //         link: true,
    //         text: this.queue.name + ' Records',
    //     },
    // ];
  },
  watch: {
    daterange: function (val) {
      console.log(val);
      this.getRecordByDate();
    }
  },
}
</script>

<style>
.v-data-table-header th {
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/Queues/Record.vue